<template>
  <div style="overflow-x:hidden">
    <div class="horizonal-tab">
      <van-tabs v-model="current" @click="onClickItem">
        <van-tab :title="item.name" :name="item.id" v-for="(item, index) in items" :key="index">
        </van-tab>
      </van-tabs>
    </div>
    <!-- 海报显示 -->
    <div class="qrCode" v-if="current == 1">
      <div class="post">
        <div class="wrapper" ref="canvasDom">
          <div class="image" :style="renderStyle">
            <!-- <img ref="image" class="cardImg" :src="imageData.creditImageBase64" /> -->
            <img ref="image" class="cardImg" :src="imageData.creditImageBase64" />
          </div>
          <div class="particulars">
            <div class="particulars-left">
              <div style="font-size: 14px">
                {{ imageData.user.realName }}
              </div>
              <div class="fs12">手机号：{{ imageData.user.phoneNumber }}</div>
              <div class="fs12">邀请码：{{ imageData.user.referKey }}</div>
            </div>
            <div class="particulars-right">
              <!-- 将svg qrCodeUrl -->
              <div class="qrCode" v-html="qrCodeUrl"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="qrtet" style="display: flex">
        <div class="linkst" @click="link">本人办理</div>
        <div class="linkst" @click="saveUrl">我要推广</div>
      </div>
    </div>
    <img :src="posterDataUrl" alt="" />
    <!-- 奖励说明 -->
    <div v-if="current == 3" class="lmm">
      <div class="cycle">
        <div class="cycle_box">
          <div class="title">一、规则说明</div>
          <div class="cycle_box_content lem">
            <div class="temnm" v-html="
              datalist.ruleDesc
                ? datalist.ruleDesc.replace(/\n/g, '<br>')
                : ''
            "></div>
          </div>
        </div>

        <div class="cycle_box">
          <div class="title">二、活动说明</div>
          <div class="cycle_box_content cyclepag">
            <div class="uni-flex">
              <div class="cylesize"></div>
              <text class="culetext">结算周期</text>
            </div>
            <div class="temnm">{{ datalist.settleCycle }}</div>

            <div class="uni-flex">
              <div class="cylesize"></div>
              <text class="culetext">结算规则</text>
            </div>
            <div class="temnm">{{ datalist.settleRegulation }}</div>

            <!-- 表格 -->
            <table class="tableli" border stripe emptyText="暂无更多数据">
              <!-- 表头行 -->
              <tr>
                <th style="color: #000000" align="center" v-for="(item, index) in tablelist" :key="index">
                  {{ item.name }}
                </th>
              </tr>
              <!-- 表格数据行 -->
              <tr :style="
                partnerLv == item.partnerLv
                  ? 'background-color: #dddddd;'
                  : 'background-color: #ffffff;'
              " v-for="(item, index) in tableitem" :key="index">
                <td align="center">{{ item.partnerLvDescribe }}</td>
                <td v-if="datalist.s1AmoutType != null" align="center">
                  {{ item.s1Amount }}
                </td>
                <td v-if="datalist.s2AmoutType != null" align="center">
                  {{ item.s2Amount }}
                </td>
                <td align="center">{{ item.totalCommission }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="cycle_box">
          <div class="title">三、分享素材</div>
          <div class="cycle_box_content">
            <div class="material">
              <!-- 文案 -->
              <div class="matetext">{{ datalist.copywriter }}</div>
              <!--  -->
              <div class="mateuser">
                <!-- 	<div class="mateme">#点击首页生成你的专属海报#</div> -->
                <div class="mateli">
                  <div class="mateitem" v-for="(item, index) in datalist.creditPosters" :key="index">
                    <img mode="aspectFill" class="preview" @click="previewImg(item)" @load="convertToCanvas"
                      :src="item" />
                  </div>
                </div>
              </div>
            </div>
            <div class="matebottom">
              <div class="picture" @click="copywriter">
                <div class="matepicture">复制文案</div>
              </div>

              <!-- <div class="picture save" @click="downloadImage">
                <div class="matepicture">保存图片</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import { Toast } from "vant";
import { ImagePreview } from "vant";
import { getCreditDetail } from "@/api/index";
// import { debounce } from "@/utils/core.js";

import axios from "axios";
export default {
  data() {
    return {
      boxWidth: 0,
      boxHeight: 0,
      val: "", //二维码地址
      cover: "", //背景图
      current: 0, //列表切换
      items: [
        {
          id: 1,
          name: "分享海报",
        },
        {
          id: 3,
          name: "办理须知",
        },
      ], //列表
      datalist: {}, //详情内容
      referKey: "", //推荐码
      jumpLink: "", //跳转链接
      type: 1, //判断是否保存海报
      loadingText: "正在生成海报",
      filePath: "", //临时海报地址
      poster: false, //显示图片
      tablelist: [],
      tableitem: [], //返回表格数据
      partnerLv: 0, //级别
      userMessage: null,
      canvas: null,
      posterDataUrl: "",
      qrCodeUrl: "",

      imageData: {
        user: {
          realName: "",
          phoneNumber: "",
          referKey: "",
        },
      },
    };
  },

  async created() {
    this.emSize = 16;
    // 获取宽度
    let data = {
      creditId: this.$route.query.creditId,
    };
    // 获取详情
    await getCreditDetail(data.creditId, this.$store.getters.getToken).then(
      async (res) => {
        if (res.code == 200) {
          this.imageData = res.data;
          console.log(res, data, "数据");
          this.datalist = res.data;
          this.jumpLink = res.data.jumpLink;
          this.referKey = res.data.referKey;
          this.cover = res.data.creditImage;
          this.imageData.creditImageBase64 =
            "data:image/png;base64," + this.imageData.creditImageBase64;
          this.getImageInfo();
         

          // this.val = res.data.jumpLink + '&referKey=' + res.data.referKey;   //  旧的线上
          // 测试用的
          // this.val = "http://192.168.1.20:8081/userInformation/?code=00000" + '&referKey=' + res.data.referKey + "&creditId=" + data.creditId + "&channelId=" + res.data.channelId + "&t=" + res.data.jumpType
          // TODO 上线需要把这个解开
          this.val =
            res.data.jumpLink +
            "&referKey=" +
            res.data.referKey +
            "&creditId=" +
            data.creditId +
            "&channelId=" +
            res.data.channelId +
            "&t=" +
            res.data.jumpType +
            "&resource=" +
            "rys"+'&name=' + res.data.name;
          // this.val =  "http://192.168.1.20:8081/userInformation?code=GDB100Z79J" + '&referKey=' + res.data.referKey + "&creditId=" + data.creditId + "&channelId=" + res.data.channelId + "&t=" + res.data.jumpType
          this.tablelist = res.data.tableClassNameList;
          this.tableitem = res.data.creditAmountList;
          this.partnerLv = res.data.partnerLv;
          this.userMessage = res.data.user;
           //   使用qrCode将 jumpLink 装换为二维码
           let that = this;
          QRCode.toString(this.val, { type: "utf8" }, function (err, url) {
            that.qrCodeUrl =  url;
          });
        } else {
          // uni.showToast({
          // 	title: res.msg,
          // 	icon: 'none'
          // });
        }
      }
    );
  },
  computed: {
    // 获取图片信息
    renderStyle() {
      // 判断图片的宽高比
      if (this.boxWidth / this.boxHeight > 1) {
        return {
          width: "99%",
          height: "160px",
        };
      } else {
        return {
          width: "50%",
          height: "60%",
        };
      }
    },
  },
  methods: {
    // 复制链接
    saveUrl() {
      if (!this.val) return Toast("复制失败！");
      this.copyContentH5(this.val, (bool) => {
        bool ? Toast("复制成功！") : Toast("复制失败！");
      });
    },
    // 获取图片信息
    getImageInfo() {
      let img = new Image();
      img.src = this.imageData.creditImageBase64;
      img.onload = () => {
        this.boxWidth = img.width;
        this.boxHeight = img.height;
      };
    },
    async getExtensionPoster() {
      let that = this;
      let canvasDom = this.$refs.canvasDom;
      const canvas = await html2canvas(canvasDom, {
        scale: 5, //缩放比例,默认为1
        dpi: 100,
        allowTaint: true, //是否允许跨域图像污染画布
        useCORS: true,
        taintTest: true,
        borderRadis: 10,
        backgroundColor: "#fff", //画布的背景色，默认为透明
      });
      const base64 = canvas.toDataURL("image/png");
      // 将生成的海报保存到相册

      this.saveHeadImgFile(base64);
    },
    // 生成海报二维码
    // 点击切换
    onClickItem(e) {
      this.current = e;
      this.type = 1;
      if (e.currentIndex == 0) {
        this.$nextTick(function () {
          // this.$refs.qrcode._makeCode();
        });
        // this.poster = true
      }
    },
    // 获取跳转链接后参数
    getUrlParams(url) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split('?')[1]
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr.split('&')
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
      }
      return obj
    },
    // 点击办理
    link() {
      let obj = this.getUrlParams(this.val)
      this.$router.push({ path: '/userInformation', query: obj });
    },

    // 预览图片
    previewImg(item) {
      ImagePreview([item]);
    },
    // 保存图片
    convertToCanvas() {
      const imgElement = document.querySelector(".preview");
      const canvas = document.createElement("canvas");
      canvas.width = imgElement.width;
      canvas.height = imgElement.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(imgElement, 0, 0, imgElement.width, imgElement.height);
      this.canvas = canvas;
    },
    downloadImage() {
      if (!this.canvas) return;
      const image = this.canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const link = document.createElement("a");
      link.download = "downloaded-image.png";
      link.href = image;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 复制文案
    copywriter() {
      if (!this.datalist.copywriter) return Toast("复制失败！");
      this.copyContentH5(this.datalist.copywriter, (bool) => {
        bool ? Toast("复制成功！") : Toast("复制失败！");
      });
    },
    // 复制
    //h5复制文本到剪切板
    copyContentH5(content, fun) {
      let copyDom = document.createElement("div");
      copyDom.innerText = content;
      copyDom.style.position = "absolute";
      copyDom.style.top = "0px";
      copyDom.style.right = "-9999px";
      document.body.appendChild(copyDom);
      //创建选中范围
      let range = document.createRange();
      range.selectNode(copyDom);
      //移除剪切板中内容
      window.getSelection().removeAllRanges();
      //添加新的内容到剪切板
      window.getSelection().addRange(range);
      //复制
      let successful = document.execCommand("copy");
      copyDom.parentNode.removeChild(copyDom);
      if (successful) fun && fun(true);
      else fun && fun(false);
    },
    dataURLtoBlob(base64) {
      let arr = base64.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 保存到文件
    saveHeadImgFile(base64) {
      // 创建blob对象
      let blob = this.dataURLtoBlob(base64);
      // 创建a标签
      let a = document.createElement('a');
      // 创建url
      let url = window.URL.createObjectURL(blob);
      // 给
      a.href = url;
      // 设置下载的文件名
      a.download = '海报.png';
      // 点击下载
      a.click();
      // 释放url
      window.URL.revokeObjectURL(url);
    },


  },
};
</script>
  
<style lang="scss" scoped>
.nav-bar-title {
  width: 100%;
  // font-weight: 700;
  font-size: 18px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}

.anim {
  white-space: nowrap;
  display: inline-block;
  animation: 10s wordsLoop linear infinite normal both;
}

.title {
  position: relative;

  &:after {
    position: absolute;
    height: 100%;
    width: 100%;
    content: attr(name);
  }
}

@keyframes wordsLoop {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

.qrCode {
  width: 300px;
  margin: auto;

  .post {
    height: 100%;

    .wrapper {
      height: 450px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      margin-top: 25px;
      border: 1px solid #000;

      .image {
        margin-top: 50px;
        width: 99%;
        height: 160px;

        .cardImg {
          border-radius: 12px;
          width: 100% !important;
          height: 100%;
        }
      }

      .particulars {
        display: flex;
        justify-content: space-around;
        width: 100%;

        .particulars-left {
          white-space: nowrap;
        }

        .particulars-right {
          width: 80px;
          height: 80px;

          .qrCode {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .canvasimg {
    display: flex;
    justify-content: center;
  }

  .qrlist {
    justify-content: center;
    margin-top: 5%;
  }

  .qrtet {
    justify-content: space-around;
    margin-top: 5%;

    .linkst {
      background-color: #cf142b;
      border-radius: 25px;
      color: #ffffff;
      line-height: 35px;
      padding: 0 15px 0 15px;
    }
  }
}

// 奖励说明

.material {
  padding-top: 5%;
  width: 95%;
  margin: auto;

  .mate {
    align-items: center;

    .mateimage {
      height: 40px;
      width: 40px;
      border-radius: 50%;
    }

    .matename {
      margin-left: 7.5px;
      font-weight: bold;
    }
  }

  .matetext {
    margin-top: 20px;
    font-size: 13px;
    line-height: 20px;
    font-weight: bold;
    color: #333333;
  }

  .mateuser {
    margin-top: 30px;

    .mateme {
      color: orange;
      font-weight: bold;
    }

    .mateli {
      margin-top: 20px;
      flex-flow: wrap;

      .mateitem {
        width: 32%;
        margin-left: 1%;
        display: inline-block;

        img {
          width: 100%;
          height: 100px;
        }
      }
    }
  }
}

.matebottom {
  margin-top: 20px;
  display: flex;
  line-height: 40px;
  box-sizing: border-box;
  width: 100%;
  // border-bottom: 2rpx solid #cccccc;
  // border-top: 2rpx solid #cccccc;
  font-weight: bold;
  letter-spacing: 2px;
  justify-content: space-evenly;
  padding: 0 40px;

  .picture {
    justify-content: center;
    width: 88px;
    height: 38px;
    border-radius: 19px;
    border: 0.5px solid #e02020;
    display: flex;
    box-sizing: border-box;

    .mateicon {
      .mateimage {
        width: 18px;
        height: 18px;
      }
    }

    .matepicture {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }

  .save {
    background: linear-gradient(225deg, #c41919 0%, #f72a2a 100%);
    color: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(197, 45, 45, 0.2);
  }
}

.lmm {
  width: 100%;
  padding-bottom: 20px;
  background-color: #f7f7f7;
  margin-top: 2%;
}

.reward {
  border-bottom-left-radius: 12.5px;
  border-bottom-right-radius: 12.5px;
  width: 70px;
  line-height: 35px;
  margin: auto;
  background-color: #cf142b;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
}

.uni-ico {
  position: absolute;
  right: 0px;
  top: 2.5px;
}

.wrap {
  text-align: center;
  text-align: center;
  line-height: 50px;
  font-weight: bold;
}

.line {
  display: inline-block;
  width: 10px;
  border-top: 3px solid #cccccc;
  vertical-align: 5px;
  margin: 10px 5px 0 5px;
}

.cycle {
  width: 90%;
  margin: auto;
  background: #ffffff;

  .cycle_box {
    .title {
      height: 45px;
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      background-color: #f7f7f7;
    }

    .cycle_box_content {
      background: #ffffff;
      border-radius: 12px;
      padding: 15px;

      .uni-flex {
        margin-bottom: 5px;
        margin-top: 7.5px;

        .cylesize {
          background-color: #cf142b;
          font-weight: bold;
          width: 4px;
        }

        .culetext {
          margin-left: 10px;
          line-height: 15px;
          font-size: 15px;
        }
      }

      .temnm {
        color: #333333;
        font-size: 15px;
      }
       

      .material {
        padding: 0;

        .matetext {
          margin: 0;
          color: #333333;
          font-size: 15px;
          font-weight: 400;
        }

        .mateuser {
          margin-top: 0px;
        }
      }
    }
  }
}
::v-deep p {
         margin: 0;
      }
.tableli {
  width: 100%;
  margin-top: 5%;
  border-collapse: collapse;
}

table,
table tr td {
  border: 1px solid #ccc;
  padding: 8px 10px;
}
table,
table tr th {
  border: 1px solid #ccc;
  padding: 8px 10px;
}

table tr th:nth-child(2) {
  border-left: none;
  border-right: none;
}

table tr td:nth-child(1) {
  border-bottom: none;
}

table tr td:nth-child(2) {
  border-bottom: none;
}

table tr td:nth-child(3),
table tr:last-child td {
  border-bottom: 1px solid #ccc;
}
.fs12 {
  font-size: 12px;
}
</style>